window.toggleModal = function (e, callback) {
  var target = $(this).data('modal')

  e.preventDefault()

  $('.modal-wrapper.' + target).fadeToggle('fast', callback)

  if ($('.modal-wrapper').is(':visible')) {
    $('.modal-wrapper.' + target).attr('aria-hidden', false)
    $('#site-menu-drawer').attr('aria-hidden', true)
    $('.modal-wrapper.' + target)
      .attr('tabindex', '0')
      .focus()
  } else {
    $('#site-menu-drawer').attr('aria-hidden', false)
    $('.modal-wrapper.' + target).attr('aria-hidden', true)
    $('.modal-wrapper.' + target).removeAttr('tabindex')
  }
}

$(document.body).on('click', '[data-action="open-modal"]', toggleModal)

$(document).on('close_modal', function () {
  $('[data-action="close-modal"]:visible').trigger('click')
})

$('[data-action="close-modal"]').on('click', function (e) {
  toggleModal.call(this, e, function () {
    $(document).trigger('modal_closed')
  })
})

$('.modal-wrapper__close').on('click', function () {
  var el = $(this).parent()

  // Empty any modal form elements
  $(el).find('input[type=text], input[type=number], textarea').val('')
  $(el).find('input[type=radio], input[type=checkbox]').prop('checked', false)
  $('.error_message').remove()
  $('.error').removeClass('error')
  $(el).find('select').val('').trigger('change')
})

// Close on esc button
$(document).keyup(function (e) {
  if (e.key === 'Escape') {
    $('.modal-wrapper__close:visible').click()
  }
})

function eventTargetIsModalWrapper(e) {
  return $(e.target).is('.modal-wrapper__inner')
}

// we use a combination of mousedown and mouseup event handlers on the modal to test if the click originated and ended
// in the blacked out part of the screen
$('body').on('mousedown', '.modal-wrapper__inner', function (e) {
  if (eventTargetIsModalWrapper(e)) {
    $('body').one('mouseup', '.modal-wrapper__inner', function (e) {
      if (eventTargetIsModalWrapper(e)) $('.modal-wrapper__close:visible').click()
    })
  }
})

//automatically show pop up for group admins
$('.group_details_update').show()
$('.join_facebook_modal').show()
